import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../../components/states';
// import { useTranslation } from 'react-i18next';
import StudentForm from '../../../../components/forms/StudentForm';
import Loader from '../../../../components/Loader';
import { useFetch } from '../../../../hooks/useFetch';

export default function TeamStudentsEditPage() {
  const { itemId } = useParams();

  const { requestApi, data, error } = useFetch(`/v1/admin/children/${itemId}`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <StudentForm defaultValues={data?.data} /> : <Loader />;
}
